import { c as _c } from "react/compiler-runtime";
import { Intro as IdvIntro } from '@onefootprint/idv';
import useHostedMachine from 'src/hooks/use-hosted-machine';
const Intro = () => {
  const $ = _c(6);
  const [state, send] = useHostedMachine();
  const {
    onboardingConfig,
    businessBoKycData
  } = state.context;
  let t0;
  if ($[0] !== send) {
    t0 = () => {
      send({
        type: "introductionCompleted"
      });
    };
    $[0] = send;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] !== businessBoKycData || $[3] !== handleClick || $[4] !== onboardingConfig) {
    t1 = <IdvIntro onboardingConfig={onboardingConfig} businessBoKycData={businessBoKycData} onClick={handleClick} />;
    $[2] = businessBoKycData;
    $[3] = handleClick;
    $[4] = onboardingConfig;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default Intro;